import React, { useEffect, useRef, useState } from 'react';
import { Calendar } from 'lucide-react';
import './DateInputRu.css';

// Поле даты в формате ДД.ММ.ГГГГ. Браузерный <input type="date"> в Chrome
// показывает дату по языку системы (mm/dd/yyyy у английской Windows), и lang="ru"
// этого не меняет (аудит интерфейса, стр. 149, 211). Значение наружу — ISO
// «ГГГГ-ММ-ДД», как у обычного поля даты; календарь — браузерный, по кнопке.

const isoToRu = (iso) => {
  if (!iso) return '';
  const [y, m, d] = String(iso).slice(0, 10).split('-');
  return y && m && d ? `${d}.${m}.${y}` : '';
};

const ruToIso = (txt) => {
  const m = /^(\d{2})\.(\d{2})\.(\d{4})$/.exec(txt || '');
  if (!m) return null;
  const [, d, mo, y] = m;
  const dt = new Date(Date.UTC(+y, +mo - 1, +d));
  if (dt.getUTCFullYear() !== +y || dt.getUTCMonth() !== +mo - 1 || dt.getUTCDate() !== +d) return null;
  return `${y}-${mo}-${d}`;
};

// Точки ставим сами: набирают цифры подряд «01092026» → «01.09.2026»
const mask = (raw) => {
  const digits = raw.replace(/\D/g, '').slice(0, 8);
  let out = digits.slice(0, 2);
  if (digits.length > 2) out += '.' + digits.slice(2, 4);
  if (digits.length > 4) out += '.' + digits.slice(4);
  return out;
};

export function DateInputRu({ value, onChange, min, max, className = '', style, title, 'aria-label': ariaLabel, disabled, id }) {
  const [text, setText] = useState(isoToRu(value));
  const nativeRef = useRef(null);

  useEffect(() => { setText(isoToRu(value)); }, [value]);

  const inRange = (iso) => (!min || iso >= min) && (!max || iso <= max);

  const handleText = (e) => {
    const t = mask(e.target.value);
    setText(t);
    if (t === '') { if (value) onChange(''); return; }
    const iso = ruToIso(t);
    if (iso && inRange(iso) && iso !== value) onChange(iso);
  };

  const handleBlur = () => {
    // Недонабранную или невозможную дату не оставляем — возвращаем прежнюю
    if (text !== '' && !(ruToIso(text) && inRange(ruToIso(text)))) setText(isoToRu(value));
  };

  const openPicker = () => {
    const el = nativeRef.current;
    if (!el) return;
    try { if (el.showPicker) { el.showPicker(); return; } } catch { /* браузер без showPicker */ }
    el.focus();
    el.click();
  };

  return (
    <span className={`date-ru ${className}`} style={style} title={title}>
      <input
        type="text"
        inputMode="numeric"
        className="date-ru__text"
        id={id}
        placeholder="ДД.ММ.ГГГГ"
        value={text}
        onChange={handleText}
        onBlur={handleBlur}
        aria-label={ariaLabel}
        disabled={disabled}
      />
      <button type="button" className="date-ru__btn" onClick={openPicker} disabled={disabled}
              aria-label="Открыть календарь" title="Календарь">
        <Calendar size={14} />
      </button>
      <input
        ref={nativeRef}
        type="date"
        className="date-ru__native"
        tabIndex={-1}
        aria-hidden="true"
        value={value || ''}
        min={min}
        max={max}
        onChange={e => onChange(e.target.value)}
      />
    </span>
  );
}

export default DateInputRu;
